import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { QuickLinkService } from '../../../services/quick-link.service';
import { SidebarContentComponent } from '../sidebar/sidebar-content-component';
import { AssetPipe } from '../../../pipes/asset.pipe';
import { DigiTrainerContent } from '../../../models/digi-trainer-content';
import { Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { DigiTrainerLink } from '../../../models/digi-trainer-link';
import { ModalService } from '../../../services/modal.service';
import { TechnicalFeature } from '@lemberger/lemberger-am';
import { CrudService } from '../../../services/crud.service';

declare const MathJax;
export const DIGI_TRAINER_COOKIE_NAME = 'digiTrainerLastOpened';

@Component({
    selector: 'app-digi-trainer',
    templateUrl: './digi-trainer.component.html',
    styleUrls: ['./digi-trainer.component.scss'],
    standalone: true,
    imports: [
        AssetPipe
    ]
})
export class DigiTrainerComponent implements SidebarContentComponent, OnInit, OnDestroy {
    digiTrainerContent: DigiTrainerContent;
    lastOpenedAssignments: Array<string>;
    private subscription: Subscription;
    private crudService = inject(CrudService);

    constructor(
        private modalService: ModalService,
        private quicklinkService: QuickLinkService,
        public cookieService: CookieService) {
    }

    ngOnInit() {
        this.subscription = this.quicklinkService.digiTrainerContent$.subscribe(content => {
            this.digiTrainerContent = content;
            setTimeout(() => {
                MathJax.Hub.Queue(['Typeset', MathJax.Hub]);
                MathJax.Hub.Config({ commonHTML: { scale: 100 }});
            }, 1000)
        });

        this.quicklinkService.fetchDigiTrainerContent();

        if (this.cookieService.check(DIGI_TRAINER_COOKIE_NAME)) {
            this.lastOpenedAssignments = JSON.parse(this.cookieService.get(DIGI_TRAINER_COOKIE_NAME));
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    quicklinkClick(assignments:Array<string>): void {
        const link = new DigiTrainerLink();
        link.link = assignments.join(',');

        this.cookieService.set(DIGI_TRAINER_COOKIE_NAME, JSON.stringify(assignments), null, null, null, true);
        this.lastOpenedAssignments = assignments;

        this.crudService.logDirect(TechnicalFeature.HsmExerciseSeries);

        this.modalService.openModal(link);
    }
}
